class FormulaireFiltre {
  constructor(){
    this.formulaireButton = jQuery('#button-formulaire--filtre');
    this.formulaireChamp = jQuery('#liste-formulaire--filtre');
    this._init();
  }

  _init(){
    
    document.addEventListener('DOMContentLoaded', (event) => {
      if( this.formulaireButton ){
        this.formulaireButton.css('display','none');
        this.formulaireChamp.on('change',function(){
          jQuery('#formulaire--filtre').submit();
        });
      }  
    });
  }

}

export const formulaireFiltre = new FormulaireFiltre();